<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="view__404">
    <div class="view__404__inner">
      <ErrorBox title="Beklager, men denne siden finnes ikke." />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.view__404 {
}
</style>

<script>
import ErrorBox from '../components/ErrorBox.vue'

export default {
  components: {
    ErrorBox
  }
}
</script>
